import { request } from '@/shared/api/request'

export const getPositionsByDeptType = (deptType) => {
	return request({ url: `dict/staff/positionByDeptType/${deptType}`, method: 'GET' })
}

export const getPositionsByEstablishedPost = (code) => {
	return request({ url: `dict/staff/positionByEstablished/${code}`, method: 'GET' })
}

export const getExperience = (codeGroup) => {
	return request({ url: `dict/staff/experience/${codeGroup}`, method: 'GET' })
}

export const getLevel = (codeUnit) => {
	return request({ url: `dict/staff/level/${codeUnit}`, method: 'GET' })
}

export const getUnit = (codeGroup) => {
	return request({ url: `dict/staff/unit/${codeGroup}`, method: 'GET' })
}

export const getCategory = (params) => {
	return request({ url: `dict/findStaffCategoryByEstablishedPostCodeAndPositionCode`, method: 'GET', params })
}